import $ from 'jquery';
import CustomEvent from 'custom-event';

const namespace = 'forminterceptor';

export class FormInterceptor {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        storageTracker: null,
        type: null,
      },
      options,
    );

    if (!this.options.type) {
      return;
    }

    this.$el = $(el);
    this.el = this.$el.get(0);

    this.bindEventListeners();
  }

  bindEventListeners() {
    this.$el.one(`submit.${namespace}`, this.handleSubmit.bind(this));
  }

  removeEventListeners() {
    this.$el.off(`submit.${namespace}`);
  }

  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    event.preventDefault();

    this.broadcast('beforeSubmit');
    this.setStorage();

    this.$el.submit();
  }

  /**
   * @param {String} name
   */
  broadcast(name) {
    const event = new CustomEvent(`${namespace}:${name}`, {
      bubbles: true,
    });

    this.el.dispatchEvent(event);
  }

  setStorage() {
    this.options.storageTracker.set(this.options.type);
  }

  destroy() {
    this.removeEventListeners();
  }
}
